// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d3ffe8f","453":"ca78e854","455":"f61b85ae"}[chunkId] + ".chunk.js";
};